import { FleekError } from './FleekError';

type StorageIpfsUploadFailedErrorOptions = Record<string, never>;

export class StorageIpfsUploadFailedError extends FleekError<StorageIpfsUploadFailedErrorOptions> {
  public name = 'StorageIpfsUploadFailedError';

  constructor() {
    super({});
  }

  toString = () => `Upload failed.`;
}
